import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  deleteCard,
  getListCards,
  getPaymentServiceOptions,
  getPaymentServiceStatus,
  getPublicPaymentServiceOptions,
  getPublicPaymentServiceStatus,
  submitAddCardRequest,
  submitPaymentServiceRequest,
  submitPublicPaymentServiceRequest,
  submitUpdateCardRequest,
} from './endpoints';
import { LIST_CARDS } from './endpoints/getListCards';
import { PAYMENT_SERVICE_STATUS } from './endpoints/getPaymentInfo';
import { PAYMENT_SERVICE_OPTIONS } from './endpoints/getPaymentOptions';
import { PUBLIC_PAYMENT_SERVICE_STATUS } from './endpoints/getPublicPaymentInfo';
import { PUBLIC_PAYMENT_SERVICE_OPTIONS } from './endpoints/getPublicPaymentOptions';
import { getTokenizationStatus, TOKENIZATION_STATUS_TAG } from './endpoints/getTokenizationStatus';

export const paymentServicesApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      submitPaymentServiceRequest: submitPaymentServiceRequest(builder),
      submitPublicPaymentServiceRequest: submitPublicPaymentServiceRequest(builder),
      getPaymentServiceOptions: getPaymentServiceOptions(builder),
      getPublicPaymentServiceOptions: getPublicPaymentServiceOptions(builder),
      getPublicPaymentServiceStatus: getPublicPaymentServiceStatus(builder),
      getPaymentServiceStatus: getPaymentServiceStatus(builder),
      getListCards: getListCards(builder),
      submitAddCardRequest: submitAddCardRequest(builder),
      getTokenizationStatus: getTokenizationStatus(builder),
      submitUpdateCardRequest: submitUpdateCardRequest(builder),
      deleteCard: deleteCard(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [
      PAYMENT_SERVICE_OPTIONS,
      PUBLIC_PAYMENT_SERVICE_OPTIONS,
      PAYMENT_SERVICE_STATUS,
      PUBLIC_PAYMENT_SERVICE_STATUS,
      LIST_CARDS,
      TOKENIZATION_STATUS_TAG,
    ],
  });

export const {
  useDeleteCardMutation,
  useSubmitPaymentServiceRequestMutation,
  useSubmitPublicPaymentServiceRequestMutation,
  useGetPaymentServiceOptionsQuery,
  useGetPublicPaymentServiceOptionsQuery,
  useLazyGetPaymentServiceOptionsQuery,
  useGetPublicPaymentServiceStatusQuery,
  useGetPaymentServiceStatusQuery,
  useGetListCardsQuery,
  useSubmitAddCardRequestMutation,
  useGetTokenizationStatusQuery,
  useSubmitUpdateCardRequestMutation,
} = paymentServicesApi;
